import { PriceSlideFacet } from './../../process/ajax-collection-v3';
import { printMoney } from './../../process/pc-slate-tools';
export const ATTR_NAV_SLIDER_RANGE = 'data-slider-range';
export const SELECTOR_FACETED_NAV_SLIDER = `[${ATTR_NAV_SLIDER_RANGE}]`;

export class CustomPriceSlideFacet extends PriceSlideFacet {
  drawSlider() {
    let el = this.container.find(SELECTOR_FACETED_NAV_SLIDER);
    if(!el.length) return;

    if(typeof this.rangeSlider !== typeof undefined) this.rangeSlider.destroy();

    let [ min, max ] = this.getRange();
    if(!min || min == 'min') min = 0;
    if(!max || max == 'max') max = 0;

    let rangeMin = this.getRangeMin();
    let rangeMax = this.getRangeMax();

    this.rangeElement  = el[0];
    this.rangeSlider = this.noUiSlider.create(this.rangeElement, {
      start: [
        min ? min : rangeMin,
        max ? max : rangeMax
      ],
      step: 1,
      range: {
        'min': [ rangeMin ],
        'max': [ rangeMax ]
      },
      connect: true,
      // If you want min / max to show at extremities instead of values
      // tooltips: [
      //   { to: v => this.formatMin(v <= rangeMin * 1.05 ? 'min' : v), from: true },
      //   { to: v => this.formatMax(v >= rangeMax * 0.95 ? 'max' : v), from: true }
      // ]
      tooltips: [
        { to: v => this.formatMin(v), from: true },
        { to: v => this.formatMax(v), from: true }
      ]
    });

    this.rangeElement.noUiSlider.on('change', e => this.onSliderUpdate(e));
  }

  formatMax(max) {
    if(max != 'max') {
      max = printMoney(max);
      max = max.split('.')[0];
    }
    return max;
  }

  formatMin(min) {
    if(min != 'min') {
      min = printMoney(min);
      min = min.split('.')[0];
    }
    return min;
  }
}